import styled from 'styled-components';

export const ThemeSwitchWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 1rem 0;
    font-size: 1.3rem;
`;
ThemeSwitchWrapper.displayName = 'ThemeSwitchWrapper'